import CoreCompanyDetails from './CompanyDetails/CoreCompanyDetails';
import PortalInformation from './CompanyDetails/PortalInformationForm';
import { useState } from 'react';
import { Box, styled, useTheme } from '@mui/material';
import { Vehicle } from 'further-types/lp/vehicle';
import VerticalTabs from 'components/new/VerticalTabs';
import { match } from 'ts-pattern';
import { HoldingsTab } from './types';
import { useFormContext } from 'react-hook-form';
import { lpCompany as rules } from 'further-ui/validations';

const StyledBox = styled(Box)(() => ({
  width: '400px',
}));

type Props = {
  selectedVehicle: Vehicle;
};

const PORTAL_FIELDS: Array<keyof rules.CompanySchemaFormValues> = [
  'description',
  'companyLogo',
  'websiteUrl',
  'twitterUrl',
  'linkedinUrl',
  'stage',
  'sector',
];

const CompanyForm: React.FC<Props> = ({ selectedVehicle }) => {
  const [currentTab, setCurrentTab] = useState<HoldingsTab>(
    HoldingsTab.Details,
  );
  const theme = useTheme();
  const {
    formState: { errors },
  } = useFormContext<rules.CompanySchemaFormValues>();

  const errorColor = theme.palette.error.main;
  const hasPortalErrors = PORTAL_FIELDS.some((field) => !!errors[field]);
  const portalFieldSet = new Set<string>(PORTAL_FIELDS);
  const hasCoreErrors = Object.keys(errors).some(
    (key) => !portalFieldSet.has(key),
  );

  return (
    <VerticalTabs
      selectedTab={currentTab}
      tabs={[
        {
          label: 'Holding details',
          id: HoldingsTab.Details,
          dotColor: hasCoreErrors ? errorColor : undefined,
        },
        {
          label: 'Portal information',
          id: HoldingsTab.PortalInformation,
          dotColor: hasPortalErrors ? errorColor : undefined,
        },
      ]}
      renderContent={(tab) => (
        <StyledBox>
          {match(tab)
            .with(HoldingsTab.Details, () => (
              <CoreCompanyDetails selectedVehicle={selectedVehicle} />
            ))
            .with(HoldingsTab.PortalInformation, () => <PortalInformation />)
            .exhaustive()}
        </StyledBox>
      )}
      onTabChange={setCurrentTab}
    />
  );
};

export default CompanyForm;
